import { Modifier } from './Modifier';
export class RadialWaveModifier extends Modifier {
    constructor(disabled, parameters) {
        super('radial_wave', disabled, parameters, false);
    }
    apply(geometry) {
        if (this.disabled)
            return;
        const positions = geometry.attributes.position.array;
        const { strength, wavesPerRevolution, pattern } = this.parameters;
        for (let i = 0; i < positions.length; i += 3) {
            const x = positions[i];
            const z = positions[i + 2];
            const angle = Math.atan2(z, x);
            // Normalize angle to 0-2π range
            const positiveAngle = angle < 0 ? angle + 2 * Math.PI : angle;
            // Calculate wave phase, ensuring it cycles cleanly
            const wavePhase = (positiveAngle / (2 * Math.PI)) * wavesPerRevolution;
            let waveValue;
            switch (pattern) {
                case 'sine':
                    waveValue = Math.sin(wavePhase * 2 * Math.PI);
                    break;
                case 'sine_squared':
                    waveValue = Math.pow(Math.sin(wavePhase * 2 * Math.PI), 2);
                    break;
                case 'triangle':
                    waveValue = 2 * Math.abs(2 * (wavePhase - Math.floor(wavePhase + 0.5))) - 1;
                    break;
                case 'square':
                    waveValue = (wavePhase % 1) < 0.5 ? 1 : -1;
                    break;
                case 'sawtooth':
                    waveValue = 2 * (wavePhase - Math.floor(wavePhase)) - 1;
                    break;
                default:
                    waveValue = Math.sin(wavePhase * 2 * Math.PI);
            }
            const displacement = waveValue * strength;
            const radius = Math.sqrt(x * x + z * z);
            if (radius > 0) {
                positions[i] += (x / radius) * displacement;
                positions[i + 2] += (z / radius) * displacement;
            }
        }
        geometry.attributes.position.needsUpdate = true;
        geometry.computeVertexNormals();
    }
}
